module.exports = __webpack_public_path__ + "img/communication.7bfff030.svg";